import { Stack } from "@mui/material";
import { LanguageOutlined } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";

import { useTranslation } from "@/lib/i18n";
import { EarlyWarningTableWidgetDataWarningsInner } from "@/lib/api";
import { localizeTime } from "@/features/shared/widgets/helpers";
import { getPercentage } from "@/features/shared/widgets/early-warning-table/utils";

import Styled from "./styles";

interface EarlyWarningSelectedWarningProps {
  warning: EarlyWarningTableWidgetDataWarningsInner;
  closeSelectedWarning: () => void;
}

type LevelString = "yellow" | "orange" | "red";

const EarlyWarningSelectedWarning = ({
  warning,
  closeSelectedWarning,
}: EarlyWarningSelectedWarningProps) => {
  const { t } = useTranslation();
  return (
    <Styled.SelectedWarningOverlay>
      <Stack justifyContent="space-between" direction="row" justifyItems="flex-start">
        <Styled.TypeElement style={{ justifyContent: "flex-start" }}>
          <img src={`/icons/phenomena_${warning.phenomenon}.svg`} />
          <strong>{t(`ewt.phenomena.${warning.phenomenon}`)}</strong>
        </Styled.TypeElement>
        <CloseIcon
          onClick={closeSelectedWarning}
          style={{ fontSize: 20, cursor: "pointer" }}
        />
      </Stack>

      <div>
        <span>
          Code {warning.level ? t(`ewt.level.${warning.level as LevelString}`) : ""}
        </span>
        &nbsp;
        <Styled.ValueElementIndicator level={warning.level} />
        &nbsp;
        <span>{getPercentage(warning.probability_percentage)}</span>
      </div>
      <div>
        {t("ewt.warning.onset")}: {localizeTime(new Date(warning.onset), "dd MMM yyyy")}
      </div>
      <div>
        {t("ewt.warning.expires")}: {localizeTime(new Date(warning.expires), "dd MMM yyyy")}
      </div>
      <Stack gap={1} direction="row" style={{ paddingTop: "10px" }}>
        <LanguageOutlined style={{ fontSize: 18 }} />
        <i>Europe/Amsterdam</i>
      </Stack>
    </Styled.SelectedWarningOverlay>
  );
};

export default EarlyWarningSelectedWarning;
